export enum FilterModalDataHooks {
  OPEN_BUTTON = 'filters-modal-open-button',
  DIALOG = 'filters-modal-dialog',
  APPLY_BUTTON = 'filters-modal-apply-button',
  CLEAR_BUTTON = 'filters-modal-clear-button',
  ACCORDION = 'filters-modal-accordion',
  CHECKBOX = 'filters-modal-checkbox',
  TIMEZONE_RADIO_BUTTON = 'filters-modal-timezone-radio-button',
  RADIO = 'filters-modal-radio-button',
  CHECKBOX_GROUP = 'filters-modal-checkbox-group',
  TIMEZONE_TEXT = 'filters-modal-timezone-text',
}
